import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedancabservicemumbai() {



  const cardData =
  {
    keyword: 'Sedan Cab Service Mumbai ',
    heading: 'Shambhu Cabs: Sedan Cab Service Mumbai',
    headingDescription: 'Shambhu Cabs offers reliable Sedan Cab Service in Mumbai, providing safe, comfortable, and hassle-free travel for families, corporate travelers, business professionals, and tourists across the city. Our fleet of well-maintained sedans ensures a smooth and enjoyable ride with spacious seating, clean interiors, and professional chauffeurs for local travel, airport transfers, outstation trips, and full-day rentals. With flexible one-way and round-trip options, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes city travel convenient, timely, and stress-free. For comfort, safety, and dependable transportation, Shambhu Cabs is the trusted choice for sedan cab services in Mumbai.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch commemorating the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel connecting Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time and symbolizes Mumbai’s urban growth. Sunrise, sunset, and nighttime views with illuminated cables provide spectacular photographic opportunities."
  },
  {
    "title": "Chor Bazaar",
    "description": "Chor Bazaar, one of India’s oldest and most famous flea markets, is renowned for antiques, vintage Bollywood memorabilia, gramophones, cameras, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, designers, and collectors explore the market to discover unique treasures. The chaotic yet vibrant atmosphere makes it an exciting spot for cultural enthusiasts and photographers."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park spans over 100 sq km in northern Mumbai, serving as a biodiversity hotspot and city escape. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling, and trekking. The ancient Kanheri Caves within the park provide historical and archaeological interest. Home to leopards, monkeys, deer, and hundreds of bird species, it offers a jungle retreat in the middle of the city, perfect for adventure and nature enthusiasts."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is a Roman Catholic church atop a hill in Bandra. Known for its Gothic architecture, peaceful interiors, and panoramic views of the sea, it attracts devotees and tourists alike. The annual Bandra Fair in September draws large crowds for prayers, cultural programs, and local food. The church symbolizes Mumbai’s religious harmony and cultural diversity."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda in Gorai is a massive meditation hall and a monument to peace. Featuring the world’s largest stone dome built without supporting pillars, it serves as a center for learning Vipassana meditation. The pagoda’s serene atmosphere, golden interiors, and scenic gardens attract spiritual seekers and tourists. Visitors gain insight into India’s meditation traditions while enjoying panoramic views of the surrounding landscapes."
  }
],




"services": [
  {
    "name": "Sedan Taxi Mumbai",
    "description": "Sedan Taxi Mumbai offers comfortable and reliable sedan rides across the city. Ideal for office commutes, airport transfers, and local travel, ensuring a smooth and safe journey in air-conditioned sedans."
  },
  {
    "name": "Sedan Car Rental Mumbai",
    "description": "Sedan Car Rental Mumbai provides a range of sedan cars for rent with flexible packages for local and outstation travel. Perfect for family trips, business travel, or city rides with professional drivers."
  },
  {
    "name": "Dzire Sedan Cab Mumbai",
    "description": "Dzire Sedan Cab Mumbai offers affordable and spacious AC rides for city and intercity travel. Reliable service, professional chauffeurs, and comfortable seating make it perfect for all travel needs."
  },
  {
    "name": "Etios Sedan Cab Mumbai",
    "description": "Etios Sedan Cab Mumbai provides safe and efficient sedan rides in Toyota Etios for local, airport, and long-distance travel. Enjoy comfort, punctuality, and professional driving service."
  },
  {
    "name": "Honda City Rental Mumbai",
    "description": "Honda City Rental Mumbai offers premium sedan rides for business or leisure travel. Spacious interiors, AC comfort, and experienced drivers ensure a smooth journey within and outside Mumbai."
  },
  {
    "name": "Affordable Sedan Cab Mumbai",
    "description": "Affordable Sedan Cab Mumbai provides budget-friendly sedan rides without compromising on safety or comfort. Ideal for local commutes, airport pickups, and outstation travel."
  },
  {
    "name": "AC Sedan Taxi Mumbai",
    "description": "AC Sedan Taxi Mumbai ensures a comfortable and cool ride across Mumbai in air-conditioned sedans. Perfect for city rides, airport transfers, and business travel."
  },
  {
    "name": "Sedan Outstation Cab Mumbai",
    "description": "Sedan Outstation Cab Mumbai specializes in intercity travel, providing comfortable and spacious sedans for long-distance trips, weekend getaways, and family outings."
  },
  {
    "name": "Sedan Local Ride Mumbai",
    "description": "Sedan Local Ride Mumbai offers convenient city travel with professional drivers, safe and comfortable AC sedans, ideal for daily commute, shopping, or city tours."
  },
  {
    "name": "Sedan Corporate Cab Mumbai",
    "description": "Sedan Corporate Cab Mumbai provides professional chauffeur-driven sedans for business and corporate travel. Punctual, reliable, and comfortable rides for office staff and executives."
  },
  {
    "name": "Sedan Airport Cab Mumbai",
    "description": "Sedan Airport Cab Mumbai ensures timely airport pickups and drops with AC sedans. Comfortable, spacious, and safe rides for a stress-free airport transfer experience."
  },
  {
    "name": "Premium Sedan Service Mumbai",
    "description": "Premium Sedan Service Mumbai offers high-quality sedan rides for business or leisure. Professional drivers, luxurious interiors, and reliable service ensure a top-class travel experience."
  },
  {
    "name": "4-Seater Sedan Mumbai",
    "description": "4-Seater Sedan Mumbai provides comfortable seating for small families or groups, ideal for city rides, airport transfers, and intercity trips with AC comfort and professional drivers."
  },
  {
    "name": "Best Sedan Taxi Mumbai",
    "description": "Best Sedan Taxi Mumbai offers top-rated sedan cabs with experienced drivers, punctual service, and comfortable interiors for city, airport, and outstation travel."
  },
  {
    "name": "Comfortable Sedan Ride Mumbai",
    "description": "Comfortable Sedan Ride Mumbai ensures smooth and relaxing travel in air-conditioned sedans, suitable for both short city trips and long-distance journeys."
  },
  {
    "name": "Online Sedan Cab Booking",
    "description": "Online Sedan Cab Booking Mumbai allows instant booking of sedan cabs through a simple online platform. Flexible, reliable, and convenient for local, airport, and outstation travel."
  },
  {
    "name": "Sedan Car Hire Near Me",
    "description": "Sedan Car Hire Near Me offers quick access to nearby sedan rentals in Mumbai. Perfect for immediate city rides, airport transfers, or outstation trips with professional drivers."
  }
],

"tableData": [
  ["Sedan Taxi Mumbai", "Sedan Car Rental Mumbai"],
  ["Dzire Sedan Cab Mumbai", "Etios Sedan Cab Mumbai"],
  ["Honda City Rental Mumbai", "Affordable Sedan Cab Mumbai"],
  ["AC Sedan Taxi Mumbai", "Sedan Outstation Cab Mumbai"],
  ["Sedan Local Ride Mumbai", "Sedan Corporate Cab Mumbai"],
  ["Sedan Airport Cab Mumbai", "Premium Sedan Service Mumbai"],
  ["4-Seater Sedan Mumbai", "Best Sedan Taxi Mumbai"],
  ["Comfortable Sedan Ride Mumbai", "Online Sedan Cab Booking"],
  ["Sedan Car Hire Near Me", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Sedan Cab Service in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers premium sedan cab services in Mumbai, ideal for city travel, airport transfers, and business or personal trips in comfort."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Sedans",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced sedans to enjoy a smooth and luxurious ride across Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Mumbai routes, ensuring timely, safe, and hassle-free journeys in a sedan cab."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We provide clear, upfront pricing—fuel, tolls, and driver allowances included—making your sedan cab service stress-free and reliable."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your sedan travel needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All sedan cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your sedan cab experience in Mumbai convenient and worry-free."
  }
]
















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide sedan cab service in Mumbai?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable sedan cab services in Mumbai for local travel, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book a sedan cab in Mumbai with Shambhu Cabs?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for hassle-free bookings.',
  },
  {
    question: 'What types of sedans are available for cab service in Mumbai?',
    answer: 'Shambhu Cabs provides a wide range of sedans, including Swift Dzire, Honda Amaze, and other premium sedans suitable for individual and family travel.',
  },
  {
    question: 'Are drivers experienced for sedan cab services in Mumbai?',
    answer: 'Yes, our drivers are licensed, professional, and well-acquainted with Mumbai routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for sedan cab service in Mumbai?',
    answer: 'Absolutely. You can select any pickup and drop-off points within Mumbai according to your convenience.',
  },
  {
    question: 'Is sedan cab service available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock sedan cab services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for sedan cab services in Mumbai?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure passenger well-being.',
  },
  {
    question: 'What payment options are available for sedan cab service in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during sedan cab journeys in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your sedan cab journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Patel',
    feedback: 'Shambhu Cabs’ sedan service in Mumbai is punctual and comfortable. The driver was professional and the car clean.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Rao',
    feedback: 'Highly recommend Shambhu Cabs for sedan cab rides in Mumbai. Smooth booking process and excellent service throughout the trip.',
    rating: 5,
  },
];































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Sedan Cab Service in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/sedan-cab-mumbai.jpg",
  "description": "Shambhu Cabs offers premium sedan cab services in Mumbai including Dzire, Etios, and Honda City. Ideal for airport transfers, corporate travel, local rides, and outstation trips. Comfortable and reliable 4-seater sedans with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/sedan-cab-service-mumbai"
  }
};





  return (
    <div>

<Helmet>
  <title>Sedan Cab Service in Mumbai | Dzire, Etios & Honda City | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book premium sedan cab services in Mumbai with Shambhu Cabs. Choose from Dzire, Etios, or Honda City for airport transfers, corporate trips, local rides, and outstation journeys. Reliable 4-seater sedans with professional drivers."
  />

  <meta
    name="keywords"
    content="Sedan Taxi Mumbai, Sedan Car Rental Mumbai, Dzire Sedan Cab Mumbai, Etios Sedan Cab Mumbai, Honda City Rental Mumbai, Affordable Sedan Cab Mumbai, AC Sedan Taxi Mumbai, Sedan Outstation Cab Mumbai, Sedan Local Ride Mumbai, Sedan Corporate Cab Mumbai, Sedan Airport Cab Mumbai, Premium Sedan Service Mumbai, 4-Seater Sedan Mumbai, Best Sedan Taxi Mumbai, Comfortable Sedan Ride Mumbai, Online Sedan Cab Booking, Sedan Car Hire Near Me"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sedancabservicemumbai;